import { Button, IconButton, Popover } from "@material-ui/core"
import React, { useState } from "react"
import useStyles from "../../styles"
import { Download, Upload } from "lucide-react"
import OptionsSvg from "../../../assets/options"
import { useTheme } from "@material-ui/core/styles"
import useContatosExportacao from "../../../hooks/useContatosExportacao"

const Options = ({ handleOpenImportModal }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const theme = useTheme()
  const { lExportando, exportarContatos } = useContatosExportacao()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? "simple-popover" : undefined

  return (
    <div>
      <IconButton
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        style={{
          display: "flex",
          padding: theme.espacamento.spacing300,
          borderRadius: theme.radius.radius300,
          justifyContent: "center",
          alignItems: "center",
          gap: theme.espacamento.spacing300,
        }}
      >
        <OptionsSvg />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        className={classes.paperPopover}
      >
        <div className={classes.popover}>
          <Button
            disableRipple
            variant="text"
            onClick={() => {
              handleOpenImportModal()
              handleClose()
            }}
            className={classes.buttonPopover}
            style={{
              textTransform: "none",
            }}
          >
            <Download size={24} /> Importar contatos
          </Button>

          <Button
            disableRipple
            variant="text"
            fontSize="small"
            disabled={lExportando}
            onClick={() => exportarContatos(handleClose)}
            className={classes.buttonPopover}
            style={{
              textTransform: "none",
            }}
          >
            <Upload size={24} /> {lExportando ? "Exportando..." : "Exportar contatos"}
          </Button>
        </div>
      </Popover>
    </div>
  )
}

export default Options
